import { motion, AnimatePresence } from 'framer-motion'
import LinkDetailPanel, { type LinkDetailPanelProps } from './LinkDetailPanel'

/** 패널이 없는 기본값 — 플랜을 아직 모를 때는 잠긴 것으로 본다 */
const LOCKED_FEATURES = {
  plan: 'free',
  passwordProtection: false,
  expirationDates: false,
}

type LinkDetailDrawerProps = Omit<LinkDetailPanelProps, 'url' | 'features'> & {
  url: LinkDetailPanelProps['url'] | null
  features?: LinkDetailPanelProps['features']
}

const SLIDE = { type: 'tween', duration: 0.25 } as const

/** 목록 오른쪽에서 밀려 들어오는 상세 서랍 */
export default function LinkDetailDrawer({
  url,
  features,
  ...panelProps
}: LinkDetailDrawerProps) {
  return (
    <AnimatePresence>
      {url && (
        <>
          {/* 바탕을 눌러도 닫힌다. X 버튼만으로는 빠져나오기 번거롭다. */}
          <motion.div
            key="link-detail-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={SLIDE}
            onClick={panelProps.onClose}
            aria-hidden="true"
            className="fixed inset-0 z-30 bg-black/20"
          />
          <motion.div
            key="link-detail"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={SLIDE}
            className="fixed bottom-0 right-0 top-16 z-40 w-full max-w-[440px] shadow-2xl"
          >
            <LinkDetailPanel
              url={url}
              features={features ?? LOCKED_FEATURES}
              {...panelProps}
            />
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}
